export const builder_listTestimonials = (): void => {
  const builder_listTestimonials_components = document.querySelectorAll('.js-builder_listTestimonials')

  builder_listTestimonials_components.forEach(component => {
    const elementFilterForm: HTMLFormElement | null = component.querySelector('.js-builder_listTestimonials-form')
    const elementFilterTags1: HTMLSelectElement | null = component.querySelector('.js-builder_listTestimonials-filter-tags1')
    const elementFilterTags2: HTMLSelectElement | null = component.querySelector('.js-builder_listTestimonials-filter-tags2')
    const elementFilterTags3: HTMLSelectElement | null = component.querySelector('.js-builder_listTestimonials-filter-tags3')
    const elementFilterReset: HTMLDivElement | null = component.querySelector('.js-builder_listTestimonials-filter-reset')
    const elementNoResults: HTMLDivElement | null = component.querySelector('.js-builder_listTestimonials-no-results')
    const elementListTestimonials = component.querySelectorAll('.js-builder_listTestimonials-testimonial')

    const listElementFilters = [elementFilterTags1, elementFilterTags2, elementFilterTags3]

    listElementFilters.forEach(filter => {
      if (filter) {
        filter.addEventListener('change', () => {
          filterList()
          if (elementFilterReset) {
            elementFilterReset.classList.remove('-isHidden')
          }
        })
      }
    })

    if (elementFilterForm) {
      elementFilterForm.addEventListener('reset', () => {
        setTimeout(() => {
          filterList()
          if (elementFilterReset) {
            elementFilterReset.classList.add('-isHidden')
          }
          if (elementNoResults) {
            elementNoResults.classList.add('-isHidden')
          }
        }, 50)
      })
    }

    const filterList = () => {
      if (!elementListTestimonials) return

      const tags1idFilterValue = (elementFilterTags1?.value) ? Number(elementFilterTags1.value) : false
      const tags2idFilterValue = (elementFilterTags2?.value) ? Number(elementFilterTags2.value) : false
      const tags3idFilterValue = (elementFilterTags3?.value) ? Number(elementFilterTags3.value) : false

      let noShowing = false

      elementListTestimonials.forEach(testimonial => {
        if (!(testimonial instanceof HTMLElement)) return

        const tags1idList = (testimonial.dataset.jsTags1IdList) ? testimonial.dataset.jsTags1IdList.split(',').map(Number) : []
        const tags2idList = (testimonial.dataset.jsTags2IdList) ? testimonial.dataset.jsTags2IdList.split(',').map(Number) : []
        const tags3idList = (testimonial.dataset.jsTags3IdList) ? testimonial.dataset.jsTags3IdList.split(',').map(Number) : []

        if ((tags1idFilterValue && !tags1idList.includes(tags1idFilterValue))) {
          testimonial.classList.add('-isHidden')
          return
        }
        if (tags2idFilterValue && !tags2idList.includes(tags2idFilterValue)) {
          testimonial.classList.add('-isHidden')
          return
        }
        if (tags3idFilterValue && !tags3idList.includes(tags3idFilterValue)) {
          testimonial.classList.add('-isHidden')
          return
        }

        testimonial.classList.remove('-isHidden')
        noShowing = true
      })

      if (noShowing) {
        if (elementNoResults) {
          elementNoResults.classList.add('-isHidden')
        }
      } else {
        if (elementNoResults) {
          elementNoResults.classList.remove('-isHidden')
        }
      }
    }
  })
}
